export default __webpack_public_path__ + "static/SupremeLL-LightItalic-72a2316f403f9d54789ad8aafedd298b.woff2";